import React from 'react'
import Cookies from 'js-cookie';
import { useHistory, useLocation } from "react-router-dom";
const CustomInfoWindow = ({ position, close }) => {
    const history = useHistory();
  const location = useLocation();
  let username=Cookies.get('username');
  return (
    <section
      style={{
        position: 'relative',
        border: '1px solid',
        width: '210px',
        marginLeft: '5px',
        marginTop: '5px',
        background: '#dae3f3',
        padding: '1em',
        color:'black',
      }}
    >
      <i class="fa fa-times" aria-hidden="true" onClick={close} style={{float:"right"}}></i>
        <p style={{textAlign:"center"}}>{position.Name}</p>
        <button onClick={() => history.push("/form/" + btoa(position.id+"_"+username), {form_id: btoa(position.id+"_"+username),}) }
                class="btn btn-secondary">Analyze</button>
        <button onClick={() => history.push("/view/" + btoa(position.id+"_"+username), {form_id: btoa(position.id+"_"+username),})} 
                class="btn btn-secondary" style={{marginLeft:"2%"}}>Report</button>
    </section>
  )
}
export default CustomInfoWindow
